module.exports = __webpack_public_path__ + "media/Images/icon-check-purple-5ce1c86addb9775fd940e1f5d886b7c6.svg";